import React from "react";
import {
    DialogContent, Dialog as DialogMui, Slide, Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import cx from "classnames";
import CloseIcon from "./icons/cross-icon.svg";
import "./Dialog.css";

const Transition = React.forwardRef((props, ref) => (
    <Slide direction="left" ref={ref} {...props} mountOnEnter unmountOnExit />
));

const CrossIcon = ({ color, onClose }) => (
    <button
        className="Dialog__close"
        onClick={() => onClose()}
        style={{
            maskImage: `url('${CloseIcon}')`,
            WebkitMaskImage: `url('${CloseIcon}')`,
            backgroundColor: color,
        }}
    />
);

const Dialog = (props) => {
    const {
        children,
        open,
        onClose,
        withCross,
        withBanner,
        bannerTitle,
        bannerLeftPadding,
        className,
        closeOnOutside = true,
    } = props;
    const theme = useTheme();

    const dialogContent = (children) => (
        <>
            {withBanner ? (
                <div
                    className="Dialog__banner"
                    style={{
                        paddingLeft: bannerLeftPadding,
                    }}
                >
                    <Typography component="span" className="Dialog__banner__heading">
                        {bannerTitle}
                    </Typography>
                    <CrossIcon color={theme.palette.white} onClose={onClose} />
                </div>
            ) : (
                withCross && <CrossIcon color={theme.palette.primary.main} onClose={onClose} />
            )}
            <DialogContent className="Dialog__content">{children}</DialogContent>
        </>
    );

    return (
        <DialogMui
            className={cx("Dialog", className)}
            aria-labelledby="simple-dialog-title"
            TransitionComponent={Transition}
            open={open}
            onClose={closeOnOutside ? onClose : (withCross || withBanner ? null : onClose)}
            PaperProps={{
                className: "Dialog__paper",
            }}
            BackdropProps={{
                className: "Dialog__backdrop",
            }}
        >
            {dialogContent(children)}
        </DialogMui>
    );
};

export default Dialog;
